import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const protocol = {
  name: 'protocol',
  schemaType: STRING_SCHEMA_TYPE,
  method(protocols = ['https'], message) {
    const allowed = Array.isArray(protocols) ? protocols : [protocols]
    const defaultMessage = `A URL deve utilizar o protocolo ${allowed.join(
      ' ou ',
    )}`

    return this.test(
      'protocol',
      message ?? defaultMessage,
      (value) =>
        !value || allowed.some((item) => value.startsWith(`${item}://`)),
    )
  },
}

export default protocol
